// Where "Redeem" links point: the GCM redemption page when it's enabled,
// otherwise the original merchant list.
export const GCM_REDEEM_ENABLED = process.env.REACT_APP_ENABLE_GCM_REDEEM === 'true';

export const REDEEM_PATH = GCM_REDEEM_ENABLED
    ? '/participant/browse-merchants-new'
    : '/participant/browse-merchants';

// Gift Card Market requires its terms to be linked wherever its merchants are offered
export const GCM_TERMS_URL = 'https://www.giftcardmarket.com/terms-and-conditions';
